import routes from 'app/team-experts/routes';

export default {
  routes,
};
